module.exports = __webpack_public_path__ + "../static/img/pings-icon.f7e6e0f1.png";